import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import swal from "sweetalert";
import axios from "axios";

const Quickdeals = () => {
  // ====================modal====================
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // ====================modal====================

  // ====================file upload======================

  
  // ====================file upload======================

  const [alldeals,UpdateDeals]=useState([]);

  const[type,pickType]=useState("");
  const[price,pickPrice]=useState("");
  const[img,pickImg]=useState("");
 
  const getdeals = () => {
    axios.get('http://localhost:1234/quickdealslist')
      .then((response) => {
        const empData = response.data;
        UpdateDeals(empData);
      })
      .catch((error) => {
        console.error('Error fetching data: ', error);
      });
  };
  
  useEffect(() => {
    getdeals();
  }, [1]);


  const save = () => {
    if (qdid === 0) {
      let url = "http://localhost:1234/quickdealslist";
      let qdinfo = {
        "type": type,
        "image": img,
        "price":price
      };

      axios
        .post(url, qdinfo) // Use Axios post method
        .then((response) => {
          swal(type, "Save Successfully", "success");
          pickType("");
          pickImg("");
          pickPrice("");
          getdeals();
        

        })
        .catch((error) => {
          console.error("Error:", error);
        });
    } else {
      let url = `http://localhost:1234/quickdealslist/${qdid}`;

      let qdinfo = {
        "type": type,
        "image": img,
        "price":price
      };

      axios
        .patch(url, qdinfo) // Use Axios patch method for update
        .then((response) => {
          swal(type, "Update Successfully", "success");
          pickType("");
          pickImg("");
          pickPrice("");

          getdeals();
          updateQd(0);
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  };

  const delquickdeal = (id, type) => {
    let url = `http://localhost:1234/quickdealslist/${id}`;

    axios
      .delete(url) // Use Axios delete method
      .then((response) => {
        swal(type, "Deleted Successfully", "success");
        getdeals();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  let [qdid, updateQd] = useState(0);
  let [mybtn, updateBtn] = useState("Save ");

  const editDeals = (index) => {
    updateQd(alldeals[index].id);
    updateBtn("Update ");

    pickType(alldeals[index].type);
    pickImg(alldeals[index].image);
    pickPrice(alldeals[index].price);
  };

  return (
    <section>
      <div className="container-fluid mt-4">
        <div className="row">
          <div className="col-lg-1 text-end">
            <Link to="/">
              <h6>
                <i class="fa fa-home" aria-hidden="true"></i>Home
              </h6>
            </Link>
          </div>
          /
          <div className="col-lg-5">
            <h6>Quickdeals</h6>
          </div>
          <div className="col-lg-10 mt-3 mb-3">
            <div className="card border-0 shadow ">
              <div className="card-header bg bg-info border-0">
                <h4>List Of Quickdeals</h4>
              </div>

              <div className="card-body">
                <div className="col-lg-12 ">
                  <div className="row text-end">
                    <div className="col-lg-6"></div>
                    <div className="col-lg-3">
                    <input type="text" placeholder="search" className="form-control"/>
                    </div>

                    <div className="col-lg-3">
                      <button
                        className="btn btn-success"
                        variant="primary"
                        onClick={handleShow}
                      >
                        Create New Quickdeals
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-lg-12 mt-3">
                  <div class="table-responsive">
                    <table class="table table-bordered  mb-0 text-nowrap">
                      <thead>
                       
                        <tr>
                          <th> Sl.No </th>
                          <th>Type</th>
                          <th> Image</th>
                          <th>Price</th>
                          <th> Action</th>
                        </tr>
                      </thead>

                      <tbody>
                          {

                            alldeals.map((deals,index)=>{
                                return(
                                    <tr key={index}>
                                        <td>{index+1}</td>
                                        
                                        <td>{deals.type}</td>
                                        <td><img src={deals.image} className="img-fluid"/></td>
                                        <td>{deals.price}</td>
                                        <td>
                                        <button
                                      onClick={function () {
                                        editDeals(index);
                                        handleShow();
                                      }.bind(this)}
                                    >
                                      Edit
                                    </button>
                                            <button onClick={delquickdeal.bind(this,deals.id,deals.type)}> Delete </button>
                                        </td>
                                    </tr>
                                )
                            })
                          }
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      {/* ========================modal start=============== */}

      <div
        className="modal show"
        style={{ display: "block", position: "initial" }}
      >
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Add Quickdeals</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Type</Form.Label>
              <Form.Control type="text" placeholder="Enter Type" onChange={e=>pickType(e.target.value)} value={type}/>
            </Form.Group>
            
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Image</Form.Label>
              <Form.Control type="file" placeholder="Enter url" onChange={e=>pickImg(e.target.value)} value={img}/>
            </Form.Group>

            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Price</Form.Label>
              <Form.Control type="number" placeholder="Enter price" onChange={e=>pickPrice(e.target.value)} value={price}/>
            </Form.Group>


          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button variant="primary"  onClick={() => {
  save();
  handleClose();}}>
              {mybtn}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </section>
  );
};


export default Quickdeals;
